import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/movies";
import { TYPE_LABEL, formatViews } from "@/lib/media";

interface PopularRankingProps {
  items: MediaItem[];
}

export default function PopularRanking({ items }: PopularRankingProps) {
  return (
    <ol className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => (
        <li key={item.id}>
          <Link
            to={`/detail/${item.id}`}
            className="group flex items-center gap-3 p-3 transition-colors hover:bg-background-100 md:gap-4 md:p-4"
          >
            <span
              className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold md:h-9 md:w-9 ${
                index < 3
                  ? "bg-accent-500 text-primary-950"
                  : "bg-background-200 text-foreground-600"
              }`}
            >
              {index + 1}
            </span>
            <div className="h-[70px] w-[48px] shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={item.cover}
                alt={`${item.title} 封面海报`}
                title={`${item.title} 中文字幕`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600 md:text-base">
                {item.title}
              </h3>
              <p className="mt-1 truncate text-xs text-foreground-400">
                {TYPE_LABEL[item.type]} · {item.genres.slice(0, 2).join(" / ")}
              </p>
            </div>
            <div className="shrink-0 text-right">
              <span className="block text-sm font-medium text-accent-600">
                {item.rating}
              </span>
              <span className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-fire-line"></i>
                {formatViews(item.views)}
              </span>
            </div>
          </Link>
        </li>
      ))}
    </ol>
  );
}